/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Payment_Choice_Modal_TitleInputs */

const es_components_payment_choice_modal_title = /** @type {(inputs: Components_Payment_Choice_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo querés pagar?`)
};

const en_components_payment_choice_modal_title = /** @type {(inputs: Components_Payment_Choice_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How would you like to pay?`)
};

/**
* | output |
* | --- |
* | "How would you like to pay?" |
*
* @param {Components_Payment_Choice_Modal_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_payment_choice_modal_title = /** @type {((inputs?: Components_Payment_Choice_Modal_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Payment_Choice_Modal_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_payment_choice_modal_title(inputs)
	return en_components_payment_choice_modal_title(inputs)
});
export { components_payment_choice_modal_title as "components.payment_choice_modal.title" }